import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useBrowserBackHandler = (splitName) => {
  const location = useLocation();

  useEffect(() => {
    if (!splitName) return;

    const handlePopState = () => {
      const redirectPath = '/' + splitName;
      localStorage.clear();
   
      // Create anchor to REMOVE referrer + force full reload
      const a = document.createElement('a');
      a.href = redirectPath;
      a.rel = 'noreferrer';
      a.target = '_self';

      document.body.appendChild(a);
      a.click();
    };

    // Listen for browser back / forward
    window.addEventListener('popstate', handlePopState);

    // Push a dummy history entry once
    if (!window.history.state?.backHandlerSet) {
      window.history.pushState(
        { backHandlerSet: true },
        '',
        window.location.href
      );
    }

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, splitName]);
};